export enum CONTACT_PREFERENCE_TYPES {
  EMAIL = 'email',
  TEXT = 'text'
}
